export default __webpack_public_path__ + "static/media/Green-Tick-Circle.9f8048cc.svg";